/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */

export const REASONS = {
  NONE: 'none',
  UNAUTHORIZED: 'Unauthorized',
  INVALID_TOKEN: 'Invalid Token',
  INVALID_IP: 'Invalid IP'
};

/**
 * @type {Object.<String, Number>}
 */
const attemptsByReason = {
  [REASONS.NONE]: 0,
  [REASONS.UNAUTHORIZED]: 0,
  [REASONS.INVALID_TOKEN]: 0,
  [REASONS.INVALID_IP]: 0
};

/**
 * The total number of reauth events
 * @returns {Number}
 */
function getReauthCount() {
  return Object.values(attemptsByReason).reduce((prev, next) => prev + next, 0);
}

/**
 * increments the number of re-auth events associated with a reason
 * @param {String} reason
 * @returns {void}
 */
function incrementReauthAttempts(reason = null) {
  if (!reason) {
    attemptsByReason[REASONS.NONE]++;
    return;
  }
  attemptsByReason[reason]
    ? attemptsByReason[reason]++
    : (attemptsByReason[reason] = 1);
}

/**
 * Returns the total of re-auth events associated with a given reason
 * @param {String} reason
 * @returns
 */
function getReauthAttemptsByReason(reason) {
  return attemptsByReason[reason] || 0;
}

export function useReauthManagement() {
  return { getReauthCount, incrementReauthAttempts, getReauthAttemptsByReason };
}
